export interface CurrentUser {
  id: string
  fullName: string
  email: string
  initials: string
  role: string
  company: string
  phone: string
  addressLine1: string
  postalCode: string
  city: string
  country: string
  province: string
  taxNumber?: string
  notes?: string
  agentCode?: string
  agentTag?: string
  canViewAll?: boolean
}

export const mockCurrentUser: CurrentUser = {
  id: "user_001",
  fullName: "Luca Buischio",
  email: "l.buischio@no-gravity.it",
  initials: "LB",
  role: "Agente commerciale",
  company: "Gea Luce",
  phone: "3475737868",
  addressLine1: "Passaggio A. Langer, 1",
  postalCode: "35016",
  city: "Piazzola sul Brenta",
  country: "Italia",
  province: "Padova",
  agentCode: "707",
  agentTag: "agente-707",
}
